'use client'

import { useState } from 'react'
import { signInAction } from '@/app/actions/auth'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const result = await signInAction(email, password)
      if (result?.error) {
        setError(result.error)
      }
      // If no error, server action called redirect() — navigation handled automatically
    } catch (err: any) {
      // redirect() throws a special NEXT_REDIRECT error — ignore it
      if (err?.digest?.startsWith('NEXT_REDIRECT')) return
      setError('Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <main
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: '#0A3D2B' }}
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/10 mb-4">
            <span className="text-3xl">🌱</span>
          </div>
          <h1 className="text-3xl font-bold text-white tracking-tight">CodeSprouts Club</h1>
          <p className="text-green-200/70 mt-2 text-sm">Sign in to your account</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Email address</label>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full px-4 py-2.5 rounded-lg border border-gray-200 text-gray-900 placeholder-gray-400 focus:outline-none text-sm"
                onFocus={e => (e.target.style.boxShadow = '0 0 0 3px rgba(29,158,117,0.2)')}
                onBlur={e => (e.target.style.boxShadow = '')}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
              <input
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-2.5 rounded-lg border border-gray-200 text-gray-900 placeholder-gray-400 focus:outline-none text-sm"
                onFocus={e => (e.target.style.boxShadow = '0 0 0 3px rgba(29,158,117,0.2)')}
                onBlur={e => (e.target.style.boxShadow = '')}
              />
            </div>

            {error && (
              <div className="flex items-start gap-2 bg-red-50 border border-red-100 text-red-700 text-sm rounded-lg px-4 py-3">
                <span className="mt-0.5">⚠️</span>
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 rounded-lg text-white font-semibold text-sm transition-opacity disabled:opacity-60"
              style={{ backgroundColor: '#1D9E75' }}
              onMouseEnter={e => !loading && ((e.target as HTMLElement).style.backgroundColor = '#178a65')}
              onMouseLeave={e => ((e.target as HTMLElement).style.backgroundColor = '#1D9E75')}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </main>
  )
}
